import { render, staticRenderFns } from "./CopyAdset.vue?vue&type=template&id=041362f8&scoped=true"
import script from "./CopyAdset.vue?vue&type=script&lang=js"
export * from "./CopyAdset.vue?vue&type=script&lang=js"
import style0 from "./CopyAdset.vue?vue&type=style&index=0&id=041362f8&prod&lang=scss&scoped=true"
import style1 from "./CopyAdset.vue?vue&type=style&index=1&id=041362f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041362f8",
  null
  
)

export default component.exports